import { useRouter } from "next/router";
import {
  ChangeEventHandler,
  FormEvent,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useThrottleFn } from "react-use";

import { RouteName } from "@/consts/RouteName";
import { SearchQueryKeyEnum } from "@/consts/SearchQueryKeyEnum";

/** hook for hanlding search input */
type UseSearchQueryOptions = {
  onSubmitEnd?: () => void;
};
export const useSearchQuery = (options: UseSearchQueryOptions = {}) => {
  const [searchBoxText, setSearchBoxText] = useState("");
  const { onSubmitEnd } = options;

  const router = useRouter();

  const clearSearch = useCallback(() => {
    setSearchBoxText("");
  }, []);

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    setSearchBoxText(e.target.value);
  }, []);

  const query = useThrottleFn((query) => query, 1000, [searchBoxText]);

  useEffect(() => {
    setSearchBoxText("");
  }, [router.route, router.query]);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();

    const searchText = e.target[SearchQueryKeyEnum.Post].value.trim();

    if (!searchText) return;

    router.push({
      pathname: RouteName.Search,
      query: {
        [SearchQueryKeyEnum.Post]: searchText,
      },
    });

    e.target[SearchQueryKeyEnum.Post].blur();
    onSubmitEnd?.();
  };

  return {
    searchBoxText,
    searchBoxOnChange: onChange,
    query,
    onSubmit,
    clearSearch,
  };
};
